<template>
<div>

<div class="animated fadeIn">
<div class="row">
<div class="col-sm-12">
<div class="card">
<div class="card-header">
<span class="title_head">Search Variant</span>
</div>
<b-collapse id="collapse1" visible>
<b-card-body>

<b-row>
<b-col md="6">
<b-form-group>
<b-form-input type="text"  placeholder="Enter Variant Name" v-model="search_varname" name="variant_name"></b-form-input>
</b-form-group>
</b-col>

<b-col md="6"> 
<!--
<button type="button" v-if="var_view === true" class="btn btn-pill btn-primary serach_bttn" @click.prevent="getTotals" style="margin-top: 24px;">  -->
<button type="button" v-if="var_view === true" class="btn btn-pill btn-primary serach_bttn" style="margin-top: 2px;" @click.prevent="getvariant">
<i class="fa fa-search"></i> Search</button>
</b-col>
</b-row>
</b-card-body>
</b-collapse>
</div>
</div>
</div>
</div>

<div class="animated fadeIn">
<div class="row">
<div class="col-sm-12">
<div class="card">
<div class="card-header">
<div class="title_head">
Variant List Table<p v-show="hide">{{ var_view }}</p>
<span v-if="var_rights === true">
<button type="button"  class="btn btn-sm btn-primary label_bttn" variant="secondary" @click.prevent="addVariant()"><i class="fa fa-plus"></i> Add Variant</button>
</span>
</div>
</div>
<div class="card-body">
<div class="row">
<div class="col-sm-12">
<div v-if="message.sucess!=''" class="alert alert-success" >
<center>{{message.sucess}}</center>
</div>
</div>
</div>
<div class="table-responsive-sm">
<vue-good-table 
:columns="columns" 
:rows="rows" 
mode="remote"
ref="my-table"
@on-page-change="onPageChange"
@on-sort-change="onSortChange"
@on-column-filter="onColumnFilter"
@on-per-page-change="onPerPageChange"
:totalRows="totalRecords"
:pagination-options="{
  enabled: true,
  perPage: 5,
}"
styleClass="vgt-table striped bordered table-sm condensed">
<template slot="table-row" slot-scope="props">
<span v-if="props.column.field == 'variant_name1'">
<span v-if="props.row.variant_id==varianteditid">
<input type="text" class="form-control" v-model="vnnameed" name="variant_id" placeholder="Enter Variant Value">
</span>
<span v-else> 
{{props.row.variant_name}}
</span>     
</span>
<span v-if="props.column.field == 'viewdtl'">
<i class="fa fa-eye" @click.prevent="viewvalue(props.row)"></i>
</span>
<span v-if="props.column.field == 'action'">

<span v-if="var_rights === true">
<span v-if="varianteditid==props.row.variant_id"><i class="fa fa-save" @click.prevent="editvariantvalue(props.row)"></i></span>
<span v-else>
<span v-if="props.row.company_id !== 'I2OCGLB'">
<i class="fa fa-edit" @click.prevent="editvn(props.row)"></i>   
<i class="fa fa-trash" @click.prevent="deletevn(props.row)"></i>
</span>
<span v-else>
<span v-if="is_admin === true">
<i class="fa fa-edit" @click.prevent="editvn(props.row)"></i>   
<i class="fa fa-trash" @click.prevent="deletevn(props.row)"></i>
</span>
<span v-else>
<i class="fa fa-edit" style="color:grey !important;"></i>
<i class="fa fa-trash" style="color:grey !important;"></i>
</span>
</span>
</span>
</span>
<span v-else>
<i class="fa fa-edit" style="color:grey !important;"></i>
<i class="fa fa-trash" style="color:grey !important;"></i>
</span>


</span>
<span v-else>
{{props.formattedRow[props.column.field]}}
</span>
</template>
<div slot="emptystate" style="text-align:center;" v-if="loading">
<i class="fa fa-spinner fa-spin"></i>&nbsp;Loading
</div>
</vue-good-table>

<b-modal title="Add Variant" no-close-on-esc no-close-on-backdrop hide-footer class="modal-info" v-model="largeModal" @ok="largeModal = false">
<div class="row">
<div class="col-md-12">
<div class="form-group" >
<label for="name">Variant Name :<span class="star">*</span></label>
<b-form-input  ref="txtvnname" type="text" class="form-control" :class="{'is-invalid':error.errorname}" v-model="vnname" name="variant_id" placeholder="Enter Variant Name"></b-form-input>
<small  class="form-text text-muted" v-if="error.errorname"><strong style="color: red;">{{error.errorname}}</strong></small>
</div>
</div>
</div>
<div class="card-footer modal_footer">
<button type="save" class="btn btn-sm btn-primary" @click.prevent="savevn()">
<i class="fa fa-dot-circle-o"></i> Save</button>
</div>
</b-modal>

<b-modal title="Variant Value" no-close-on-esc no-close-on-backdrop hide-footer size="lg" class="modal-info" v-model="largeModal1" @ok="largeModal1 = false">
<div class="row">
<div class="col-sm-12">
<div v-if="message.sucess1!=''" class="alert alert-success" >
<center>{{message.sucess1}}</center>
</div>
</div>
</div>
<div class="form-row">
<label class="col-sm-2 col-form-label">Variant Name:-</label>
<label class="col-sm-10 col-form-label">{{variantname}}</label>
</div>
<div class="row" style="margin-bottom:22px;">
<div class="col-md-12">
<div class="form-row">
<label for="name" class="col-sm-2 col-form-label">Variant Value :<span class="star">*</span></label>
<div class="col-sm-4">
<b-form-input ref="txtvnvalue" type="text" class="form-control" v-model="vnaddvalue"  name="variant_id" placeholder="Enter Variant Value (eg. Red)" :class="{'is-invalid':error.errorvalue}"></b-form-input>
<small  class="form-text text-muted" v-if="error.errorvalue" ><strong style="color: red;">{{error.errorvalue}}</strong></small>
</div>
<div class="col-sm-6" v-if="var_rights === true">          
<button type="button" style="border-radius: 15px; " class="btn btn-pill btn-primary" @click.prevent="addvalue">Add Value</button>
</div>
</div>
</div>
</div>

<vue-good-table 
:columns="columns1" 
:rows="rows1" 
mode="remote"
ref="my-table1"
@on-page-change="onPageChange1"
@on-sort-change="onSortChange1"
@on-column-filter="onColumnFilter1"
@on-per-page-change="onPerPageChange1"
:totalRows="totalRecords1"
:pagination-options="{enabled: true,
  perPage: 10}"
  styleClass="vgt-table striped bordered table-sm condensed" :lineNumbers="true">
  <template slot="table-row" slot-scope="props">
  <span v-if="props.column.field == 'viewdtl'">
  <span v-if="editvalue==props.row.id">         
  <input type="text" class="form-control" v-model="vnaddvalueed"  name="variant_id" placeholder="Enter Variant Id" style="width:170px;"> 
  </span> 
  <span v-else>
  {{props.row.variant_value}}
  </span>   
  </span>
  <span v-if="props.column.field == 'action'">

  <span v-if="var_rights === true">
  <span v-if="editvalue==props.row.id">
  <i class="fa fa-save" @click.prevent="saveedvalue(props.row)"></i>   
  </span>
  <span v-else>
  <span v-if="props.row.company_id != 'I2OCGLB'">
  <i class="fa fa-edit" @click.prevent="editvnvalue(props.row)"></i>   
  <i class="fa fa-trash" @click.prevent="deletevnvalue(props.row)"></i>
  </span>
  <span v-else>
  <span v-if="is_admin === true">
  <i class="fa fa-edit" @click.prevent="editvnvalue(props.row)"></i>   
  <i class="fa fa-trash" @click.prevent="deletevnvalue(props.row)"></i>
  </span>
  <span v-else>
  <i class="fa fa-edit" style="color:grey !important;"></i>
  <i class="fa fa-trash" style="color:grey !important;"></i>
  </span>
  </span>
  </span>
  </span>
  <span v-else>
  <i class="fa fa-edit" style="color:grey !important;"></i>
  <i class="fa fa-trash" style="color:grey !important;"></i>
  </span>      
  </span>
  <span v-else>
  {{props.formattedRow[props.column.field]}}
  </span>
  </template>
  <div slot="emptystate" style="text-align:center;" v-if="loading">
  <i class="fa fa-spinner fa-spin"></i>Loading
  </div>
  </vue-good-table>
  </b-modal>
  </div>
  </div>
  </div>
  </div>
  </div>
  </div>    
  <Spinner v-if="loading"></Spinner>     
  </div>
  </template>

  <script>
  import Spinner from '../../spinner.vue'
  export default {
    name: 'Variant',
    components: { Spinner },
    data(){
      return {
      // pg_view:false,
      // pg_rights:false,
      is_admin: false,
      shpfrst_time:false,
      vfrst_time:false,
      hide:false,
      vnaddvalueed:'',
      editmodel:false,
      vnaddvalue:'',
      largeModal1:false,
      largeModal:false,
      loading:false,
      vnname:'',
      search_varname:'',
      vnvalue:'',
      vnidsearch:'',
      variantname:'',
      variantid:'',
      editvalue:'',
      vnnameed:'',
      varianteditid:'',
      totalRecords: 0,
      serverParams: {
       columnFilters: {
       },
       sort: {},
       page: 1, 
       perPage: 5
     },
     serverParams1: {
       columnFilters: {
       },
       sort: {},
       page: 1, 
       perPage: 10
     },
     totalRecords1: 0,
     columns: [
     {
      label: 'Variant Name',
      field: 'variant_name1',
      width: '60% !important'
    },
    {
      label: 'Variant Value',
      field: 'viewdtl',
      width: '30% !important'
    },
    {
      label: 'Action',
      field: 'action',
      width: '10% !important'
    },
    ],
    columns1: [
    {
      label: 'Variant Value',
      field: 'viewdtl',
      width: '90% !important'
    },
    {
      label: 'Action',
      field: 'action',
      width: '10% !important'
    },
    ],
    rows:[],
    rows1:[],
    error:{
      errorname:false,
      errorided:'',
      errornameed:'',
      errorvalue:false,
    },
    message:{
      sucess:'',
      sucess1:'',
    }
  };
},
computed:{
  var_view: function(){
    if(this.$store.getters.get_var_view === true){
      this.shopuser('comp');
      this.getvariant('comp');
      this.is_admin = this.$store.getters.get_is_admin
      return true
    }
    else{
      return false
    }
  },
  var_rights: function(){
    return this.$store.getters.get_var_rights
  }
},

methods:{

  updateParams(newProps) {
    this.serverParams = Object.assign({}, this.serverParams, newProps);
  },

  onPageChange(params) { 
   this.updateParams({page: params.currentPage});
   this.getvariant();
 },

 onPerPageChange(params) {
  this.updateParams({perPage: params.currentPerPage,page:1});
  this.getvariant();
},

onSortChange(params) {
  this.updateParams({
    sort: {
      type: params.sortType,
      field: this.columns[params.columnIndex].field,
    },page:1
  });
  this.getvariant();
},

onColumnFilter(params) {
  this.updateParams(params);
  this.getvariant();
},

updateParams1(newProps) {
  this.serverParams1 = Object.assign({}, this.serverParams1, newProps);
},

onPageChange1(params) { 
  this.updateParams1({page: params.currentPage});
  this.getvariantvalue();
},

onPerPageChange1(params) {
  this.updateParams1({perPage: params.currentPerPage,page:1});
  this.getvariantvalue();
},

onSortChange1(params) {
  this.updateParams1({
    sort: {
      type: params.sortType,
      field: this.columns1[params.columnIndex].field,
    },page:1
  });
  this.getvariantvalue();
},

onColumnFilter1(params) {
  this.updateParams1(params);
  this.getvariantvalue();
},


shopuser(val){
  if(val === 'comp'){
    if(this.shpfrst_time === false){
      this.shpfrst_time = true
    }
    else{
      return
    }
  }
  var _this=this
  this.$http.get('/api/shopusers').then(function(response){

  }).catch(function(error){
    if (error.response.status === 401) {
      localStorage.clear();
      _this.$store.commit('SET_AUTH_USER', null)
      _this.$router.push('/');
    }
    if(error.response.data.error.message === "Cannot read property 'cmpname' of null"){
      localStorage.clear();
      _this.$store.commit('SET_AUTH_USER', null)
      _this.$router.push('/');
    }
  })
},
viewvalue(data){
  this.message.sucess1 = ''
  this.largeModal1=true;
  this.variantname=data.variant_name;
  this.variantid=data.variant_id;
  this.getvariantvalue();
},
editvnvalue(data){
  this.editvalue=data.id;
  this.vnaddvalueed=data.variant_value;
},
deletevnvalue(data){
  var r = confirm("Are you sure you want to delete?");
  if (r == true) {
    var _this=this
    this.loading=true
    this.$http.delete('/api/variantvalues/'+data.id).then(function (response) {
      _this.loading=false
      _this.getvariantvalue();
    })
    .catch(function (error) {
      console.log(error);
    });
  }
},
addVariant(){
  this.vnname = ''
  this.error.errorname = false
  this.largeModal = true
},
saveedvalue(data1){
  var _this=this
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  if(this.vnaddvalueed == ''){

  }else{
    this.loading=true
    var data={
      variant_value:this.vnaddvalueed,
    }    
    this.$http.post('/api/variantvalues/update?where[id]='+data1.id,data).then(function(response){
      _this.loading=false
      _this.message.sucess1="Variant Value Updated Successfully";
      setTimeout(function(){ _this.message.sucess=false;}, 3000);
      _this.getvariantvalue();
      _this.editvalue='';
    }).catch(function(error){
      _this.loading=false;
      _this.message.sucess1="SomeThing Went Wrong"
    })
  }
},

editvn(data){
  this.editmodel=true;
  this.vnnameed=data.variant_name;
  this.varianteditid=data.variant_id;
},

editvariantvalue(data1){
  var _this=this;
  document.body.scrollTop = 0;
  document.documentElement.scrollTop = 0;
  var data={variant_name:this.vnnameed}
  if(this.vnnameed == ''){

  }else{
    this.loading=true
    this.$http.post('/api/variants/update?where[variant_id]='+data1.variant_id,data).then(function(response){
       _this.loading=false
      _this.message.sucess="Variant Updated Successfully";
      setTimeout(function(){ _this.message.sucess=false;}, 3000);
      _this.getvariant();
      _this.varianteditid='';
    }).catch(function(error){
      _this.loading=false;
      _this.message.sucess="SomeThing Went Wrong"
    })
  }
},

getvariantvalue(){
  var _this=this
  var filteParam = {};
  filteParam.page = this.serverParams1.page;
  filteParam.perPage = this.serverParams1.perPage;
  filteParam.sort = this.serverParams1.sort;
  this.$http.get('/api/variantvalues?params='+JSON.stringify(filteParam)+'&filter[where][variant_id]='+_this.variantid).then(function(response){
    _this.totalRecords1 = response.data[0].totalRecords;
    response.data.shift()
    if(response.data != undefined)
      _this.rows1=response.data
  }).catch(function(error){
    console.log(error)
  })
},

getvariant(val){
  if(val === 'comp'){
    if(this.vfrst_time === false){
      this.vfrst_time = true
    }
    else{
      return
    }
  }
  var _this=this;
  var filteParam = {};
  var data = ''
  filteParam.page = this.serverParams.page;
  filteParam.perPage = this.serverParams.perPage;
  filteParam.sort = this.serverParams.sort;
  var api=''
  if(this.search_varname != ''){
    api = '/api/variants/showVariants?params='+JSON.stringify(filteParam)+'&filter[where][variant_name][ilike]=%'+this.search_varname+'%'
  }
  else{
    api = '/api/variants?params='+JSON.stringify(filteParam)
  }
  this.loading = true
  this.$http.get(api).then(function(response){
    _this.totalRecords = response.data[0].totalRecords;
    response.data.shift()
    if(response.data != undefined)
      _this.rows=response.data
    _this.loading = false
  }).catch(function(error){
    _this.loading=false
  })
},

deletevn(val){
  var r = confirm("Are you sure you want to delete?");
  if (r == true) {
    var _this=this
    var id = val.id;
    this.loading=true
    this.$http.delete('/api/variants/'+id).then(function (response) {
      _this.loading=false
      _this.getvariant();
    })
    .catch(function (error) {
    });
  }
},

savevn(){
  this.vnname = this.vnname.trim()
  if(this.vnname==''){
    this.error.errorname='Required'  
  }
  else{
    var _this = this 
    this.loading=true
    this.$http.get('/api/variants/chk_exist?filter[where][variant_name]='+this.vnname).then(function (response){
      if(response.data.length > 0){
        _this.loading=false
        _this.vnname = ''
        _this.error.errorname = 'Variant name already exist'
        _this.$refs['txtvnname'].focus()
      }
      else{
        _this.error.errorname = false
        _this.largeModal=false;
        var data={
          variant_name:_this.vnname,
        }
        var __this = _this
        _this.$http.post('/api/variants',data).then(function(response){
          __this.loading=false;
          __this.message.sucess="Variant Added Successfully";
          setTimeout(function(){ __this.message.sucess=false;}, 2000);
          __this.getvariant()
        }).catch(function(error){
          __this.loading=false;
          __this.message.sucess="SomeThing Went Wrong"
        })
      }
    })
    .catch(function(error){
      _this.error.errorname = false
    });
  }
},

addvalue(){
  this.error.errorvalue = false
  if(this.vnaddvalue == ''){
    this.error.errorvalue = 'Required'
  }
  else{
    var _this = this
    this.loading=true
    this.$http.get('/api/variantvalues/chk_exist?filter[where][variant_value]='+this.vnaddvalue+'&filter[where][variant_id]='+this.variantid).then(function (response){
      if(response.data.length > 0){
        _this.loading=false
        _this.vnaddvalue = ''
        _this.error.errorvalue = 'Variant value already exist'
        _this.$refs['txtvnvalue'].focus()
      }
      else{
        _this.error.errorvalue = false
            // _this.largeModal1=false;
            var __this = _this
            var data={variant_id:_this.variantid,variant_value:_this.vnaddvalue}
            _this.$http.post('/api/variantvalues',data).then(function(response){
              __this.loading=false
              __this.message.sucess1="Variant Value Added Successfully";
              setTimeout(function(){ _this.message.sucess1=false;}, 2000);
              __this.getvariantvalue();
              __this.vnaddvalue='';
            }).catch(function(error){
              __this.loading=false;
              __this.message.sucess1="SomeThing Went Wrong"
            })
          }
        })
    .catch(function(error){
      _this.error.errorvalue = false
    });
  }      
}
}
};
</script>



// WEBPACK FOOTER //
// src/views/setting/variant.vue